import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type ValidAuth = {
  isAuthenticated: boolean;
  isLogout: boolean;
};

const initialState: ValidAuth = {
  isAuthenticated: true,
  isLogout: false,
};

export const ValidAuthSlice = createSlice({
  name: "token",
  initialState,
  reducers: {
    setIsAuth: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setIsLogout: (state) => {
      state.isLogout = true;
    },
    setResetAuth: (state) => {
      state.isAuthenticated = true;
      state.isLogout = false;
    },
  },
});

export const { setIsAuth, setIsLogout, setResetAuth } = ValidAuthSlice.actions;
export default ValidAuthSlice;
